import BaseUI from "../base-ui.ts";
import LogoFragment from "../fragments/logo.ts";
import State from "../../state/state.ts";
import EatOutApiClient from "../../api-client/eat-out-api-client.ts";
import V1UserGuestLoggedIn from "../../payloads/incoming/v1-user-guest-logged-in.ts";
import UiUtils from "../../utils/ui-utils.ts";
import Route from "../../enums/route.ts";
import SharedApiLogic from "../../api-client/shared-api-logic.ts";

export default class ConnectingScreen extends BaseUI {
  constructor(state: State, apiClient: EatOutApiClient, navigateCallback: (route: Route) => void) {
    super("connecting-screen", state, apiClient, navigateCallback);

    // subscribe to events
    this.apiClient.v1GuestUserLoggedInCallback = this.handleV1UserGuestLoggedIn.bind(this);

    // reset "current group" to nothing
    this.state.groupState.currentGroupId = null;
  }

  public override render(newElements: HTMLElement[] = []): HTMLDivElement {
    // logo
    const logo: LogoFragment = new LogoFragment(this.state, this.apiClient, this.navigateCallback);
    newElements.push(logo.render());

    // loading text
    const connectingText: HTMLParagraphElement = UiUtils.paragraph("Connecting...");
    newElements.push(connectingText);

    return super.render(newElements);
  }

  private handleV1UserGuestLoggedIn(v1UserGuestLoggedIn: V1UserGuestLoggedIn): void {
    SharedApiLogic.handleV1UserGuestLoggedIn(this.debug, this.state, this.navigateCallback, v1UserGuestLoggedIn);
  }
}
